// extracted by mini-css-extract-plugin
module.exports = {"back":"ConstructionControlProjects_back__1U9W_","header":"ConstructionControlProjects_header__2_FCr","th":"ConstructionControlProjects_th__1QBrF"};